import { motion } from "framer-motion";
import { Users, CalendarClock, BadgeIndianRupee, Award } from "lucide-react";
import { useLanguage } from "@/i18n/LanguageContext";

const pointIcons = [Users, CalendarClock, BadgeIndianRupee, Award];

export const WhyUs = () => {
  const { t } = useLanguage();

  return (
    <section id="why-us" className="py-24 lg:py-32 bg-[#1A1412]" data-testid="why-us-section">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          <p className="text-[#D4AF37] tracking-[0.4em] uppercase text-sm mb-4">{t.whyUs.eyebrow}</p>
          <h2 className="font-heading text-4xl sm:text-5xl text-[#FDFBF7] max-w-2xl" data-testid="why-us-heading">
            {t.whyUs.heading}
          </h2>
        </motion.div>

        <div className="mt-16 grid grid-cols-1 sm:grid-cols-2 gap-8">
          {t.whyUs.points.map((p, i) => {
            const Icon = pointIcons[i];
            return (
              <motion.div
                key={p.title}
                initial={{ opacity: 0, y: 40 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.6, delay: i * 0.1 }}
                className="flex gap-6 p-8 lg:p-10 border border-[#D4AF37]/20 bg-[#2A211D] hover:-translate-y-1 hover:border-[#D4AF37]/50 transition-all duration-300"
                data-testid={`why-us-card-${i + 1}`}
              >
                <Icon className="h-10 w-10 text-[#D4AF37] shrink-0" />
                <div>
                  <h3 className="font-heading text-2xl text-[#FDFBF7]">{p.title}</h3>
                  <p className="mt-3 text-[#B8A99A] text-sm leading-relaxed">{p.desc}</p>
                </div>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
